import React from 'react';
import { motion } from 'framer-motion';
import { handleSmoothScroll } from '../utils/scrollUtils';

const CTASection = () => {
  return (
    <section className="relative bg-indigo-600 text-white py-20 overflow-hidden">
      {/* Diagonale en bas */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-white" style={{ clipPath: 'polygon(0 100%, 100% 0, 100% 100%, 0% 100%)' }}></div>
      
      <div className="container mx-auto px-4 md:px-8 lg:px-16 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <motion.h2 
            className="text-3xl md:text-4xl lg:text-5xl font-medium mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            Prêt à faire décoller votre activité ?
          </motion.h2>
          
          <motion.p 
            className="text-lg md:text-xl opacity-90 mb-10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Rejoignez l'aventure avec une agence qui a déjà fait ces preuves. Vous êtes à deux doigts de construire le site de vos rêves !
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            viewport={{ once: true }}
            className="flex flex-col sm:flex-row justify-center gap-4"
          >
            <a 
              onClick={(e) => handleSmoothScroll(e, 'contact')} 
              className="px-5 py-2 rounded-[40px] bg-white text-[#5046E5] font-medium hover:bg-gray-100 transition-all duration-300 shadow-lg text-sm inline-flex items-center justify-center"
            >
              Démarrer mon projet
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </a>
            <a 
              onClick={(e) => handleSmoothScroll(e, 'contact')} 
              className="px-5 py-2 rounded-[40px] bg-transparent border border-white text-white font-medium hover:bg-white/10 transition-all duration-300 text-sm inline-flex items-center justify-center"
            >
              Prendre rendez-vous
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
